import React from 'react';
import PropTypes from 'prop-types';
import styled from "@emotion/styled"


const SelectionWrapper = styled.div`
    /* Rectangle 43 */
    display: flex;
    justify-content: space-between;
    
    padding: 11px 16px 11px 16px;
    width: 256px;
    height: 40px;
    /* default/gray/100 */
    cursor: pointer;
    user-select: none;
    
    background: ${props => (props.isSelected) ? "var(--accent)" : "#F4F7F9"};
    border-radius: 8px;
    
    box-shadow: ${props => props.isSelected ? "0px 4px 6px rgba(0, 0, 0, 0.05), 0px 10px 15px rgba(0, 0, 0, 0.1)" : "none"};
`;

const NameWrapper = styled.div`
    font-family: Metropolis;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height, or 100% */
    
    display: flex;
    align-items: center;
    
    /* default/shade/white */
   
    color: ${props => (props.isSelected) ? "#FFFFFF" : "#718096"};
`;

function Option({name, isSelected, onSelected, warning}) {
    return (
        <SelectionWrapper onClick={onSelected} isSelected={isSelected}>
            <NameWrapper isSelected={isSelected}>
                {name}
            </NameWrapper>
        </SelectionWrapper>
    );
}

Option.propTypes = {
    name: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired,
    warning: PropTypes.bool.isRequired,
    onSelected: PropTypes.func.isRequired
};
Option.defaultProps = {};

export default Option;
